<script>
import {Popover, Icon} from "ant-design-vue";

export default {
  name: 'LayoutHeader',
  components: {
    Popover,Icon
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    routerAndHash(path){
      location.href = path;
    },
    openWeb(url){
      window.open(url)
    },
  }
}
</script>

<template>
<div class="layout-header-wrapper">
  <div class="layout-header-logo" @click="$router.push('/')">
    <img src="../assets/images/head-logo.png" alt="logo">
  </div>
  <div class="header-menu">
    <Popover placement="bottom" trigger="hover">
      <div class="menu-item" @click="routerAndHash('/')">{{ $t('menu.menu1') }}<Icon type="caret-down" /></div>
      <div class="popover-content" slot="content">
          <div class="popover-item" @click="routerAndHash('/#p3')">{{ $t('menu.menu1_1') }}</div>
          <div class="popover-item" @click="routerAndHash('/#p5')">{{ $t('menu.menu1_2') }}</div>
          <div class="popover-item" @click="routerAndHash('/#p9')">{{ $t('menu.menu1_3') }}</div>
      </div>
    </Popover>
    <Popover placement="bottom" trigger="hover">
      <div class="menu-item"  @click="routerAndHash('/tool#tool1')">{{ $t('menu.menu2') }}<Icon type="caret-down" /></div>
      <div class="popover-content" slot="content">

        <Popover placement="rightTop" trigger="hover"
                 :get-popup-container="(triggerNode) => triggerNode.parentElement">
          <div class="popover-item" @click="routerAndHash('/tool#tool1')">{{ $t('menu.submenu2_1') }}</div>
          <div class="popover-content" slot="content">
            <div class="popover-item" @click="routerAndHash('/tool#tool1')">1.1 {{ $t('menu.submenu2_1_1') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool2')">1.2 {{ $t('menu.submenu2_1_2') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool3')">1.3 {{ $t('menu.submenu2_1_3') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool4')">1.4 {{ $t('menu.submenu2_1_4') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool5')">1.5 {{ $t('menu.submenu2_1_5') }}</div>
          </div>
        </Popover>

        <Popover placement="rightTop" trigger="hover"
                 :get-popup-container="(triggerNode) => triggerNode.parentElement">
          <div class="popover-item" @click="routerAndHash('/tool#tool6')">{{ $t('menu.submenu2_2') }}</div>
          <div class="popover-content" slot="content">
            <div class="popover-item" @click="routerAndHash('/tool#tool6')">2.1 {{ $t('menu.submenu2_2_1') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool7')">2.2 {{ $t('menu.submenu2_2_2') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool8')">2.3 {{ $t('menu.submenu2_2_3') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool9')">2.4 {{ $t('menu.submenu2_2_4') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool10')">2.5 {{ $t('menu.submenu2_2_5') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool11')">2.6 {{ $t('menu.submenu2_2_6') }}</div>
          </div>
        </Popover>

        <Popover placement="rightTop" trigger="hover"
                 :get-popup-container="(triggerNode) => triggerNode.parentElement">
          <div class="popover-item" @click="routerAndHash('/tool#tool12')">{{ $t('menu.submenu2_3') }}</div>
          <div class="popover-content" slot="content">
            <div class="popover-item" @click="routerAndHash('/tool#tool12')">3.1 {{ $t('menu.submenu2_3_1') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool13')">3.2 {{ $t('menu.submenu2_3_2') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool14')">3.3 {{ $t('menu.submenu2_3_3') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool15')">3.4 {{ $t('menu.submenu2_3_4') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool16')">3.5 {{ $t('menu.submenu2_3_5') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool17')">3.6 {{ $t('menu.submenu2_3_6') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool18')">3.7 {{ $t('menu.submenu2_3_7') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool19')">3.8 {{ $t('menu.submenu2_3_8') }}</div>
            <div class="popover-item" @click="routerAndHash('/tool#tool20')">3.9 {{ $t('menu.submenu2_3_9') }}</div>
          </div>
        </Popover>
      </div>
    </Popover>
    <Popover placement="bottom" trigger="hover">
      <div class="menu-item"  @click="routerAndHash('/deeper')">{{ $t('menu.menu3') }}<Icon type="caret-down" /></div>
      <div class="popover-content" slot="content">
        <div class="popover-item" @click="routerAndHash('/deeper#p1')">{{ $t('menu.submenu3_1') }}</div>
        <div class="popover-item" @click="routerAndHash('/deeper#p3')">{{ $t('menu.submenu3_2') }}</div>
      </div>
    </Popover>
    <Popover placement="bottom" trigger="hover">
      <div class="menu-item"  @click="routerAndHash('/clear')">{{ $t('menu.menu5') }}<Icon type="caret-down" /></div>
      <div class="popover-content" slot="content">

        <Popover placement="rightTop" trigger="hover"
                 :get-popup-container="(triggerNode) => triggerNode.parentElement">
          <div class="popover-item" @click="routerAndHash('/clear#p1')">{{ $t('menu.submenu5_1') }}</div>
          <div class="popover-content" slot="content">
            <div class="popover-item" @click="routerAndHash('/clear#p1')">{{ $t('menu.submenu5_1_1') }}</div>
            <div class="popover-item" @click="routerAndHash('/clear#p1')">{{ $t('menu.submenu5_1_2') }}</div>
            <div class="popover-item" @click="routerAndHash('/clear#p1')">{{ $t('menu.submenu5_1_3') }}</div>
            <div class="popover-item" @click="routerAndHash('/clear#p1')">{{ $t('menu.submenu5_1_4') }}</div>
          </div>
        </Popover>

        <Popover placement="rightTop" trigger="hover"
                 :get-popup-container="(triggerNode) => triggerNode.parentElement">
          <div class="popover-item" @click="routerAndHash('/clear#p2')">{{ $t('menu.submenu5_2') }}</div>
          <div class="popover-content" slot="content">
            <div class="popover-item" @click="routerAndHash('/clear#p2')">{{ $t('menu.submenu5_1_1') }}</div>
            <div class="popover-item" @click="openWeb('https://v.wjx.cn/vm/YfWgWYu.aspx#')">{{ $t('menu.submenu5_2_2') }}</div>
            <div class="popover-item" @click="openWeb('https://v.wjx.cn/vm/YfWgWYu.aspx#')">{{ $t('menu.submenu5_2_3') }}</div>
          </div>
        </Popover>

        <Popover placement="rightTop" trigger="hover"
                 :get-popup-container="(triggerNode) => triggerNode.parentElement">
          <div class="popover-item" @click="routerAndHash('/clear#p3')">{{ $t('menu.submenu5_3') }}</div>
          <div class="popover-content" slot="content">
            <div class="popover-item" @click="routerAndHash('/clear#p3')">{{ $t('menu.submenu5_3_1') }}</div>
            <div class="popover-item" @click="openWeb('https://www.zhipin.com/gongsi/02d63436b8058e2603B_2Nm1Elc~.html?ka=job-detail-company_custompage')">{{ $t('menu.submenu5_3_2') }}</div>
            <div class="popover-item" @click="openWeb('https://mp.weixin.qq.com/s/2lfQsuRnt8KEWR-Vf8tV3w?click_id=2')">{{ $t('menu.submenu5_3_3') }}</div>
            <div class="popover-item" @click="openWeb('https://v.wjx.cn/vm/YfWgWYu.aspx#')">{{ $t('menu.submenu5_3_4') }}</div>
            <div class="popover-item" @click="openWeb('https://v.wjx.cn/vm/tlVDbJd.aspx')">{{ $t('menu.submenu5_3_5') }}</div>
          </div>
        </Popover>
      </div>
    </Popover>
    <div class="menu-item" @click="routerAndHash('/#p9')">{{ $t('menu.menu4') }}<Icon type="caret-down" /></div>
    <Popover placement="bottom" trigger="hover">
      <div class="menu-item"><img src="../assets/images/lang.svg" alt="">{{ $t('lang') }}<Icon type="caret-down" /></div>
      <div class="popover-content" slot="content">
        <div class="popover-item">{{ $t('zh') }}</div>
        <div class="popover-item">{{ $t('en') }}</div>
      </div>
    </Popover>
  </div>
</div>
</template>

<style scoped lang="less">
.layout-header-wrapper{
  width: 1440px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 172px;
  .layout-header-logo{
    height: 58px;
    cursor: pointer;
    img{
      display: block;
      height: 100%;
    }
  }
  .header-menu{
    width: 880px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-left: 168px;
    .menu-item{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 15px;
      color: #fff;
      font-weight: 400;
      cursor: pointer;
      .anticon{
        color: #DFB969;
      }
    }
  }
}
.popover-content{
  .popover-item{
    color: #FFFFFFD9;
    font-size: 14px;
    height: 30px;
    line-height: 22px;
    padding: 4px;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 400;
    cursor: pointer;
    &:hover{
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
<style lang="less">
.ant-popover{
  .ant-popover-arrow{
    border-color: #000;
    display: none;
  }
  .ant-popover-inner{
    background: #17181ABF;

    backdrop-filter: blur(50px);
    box-shadow: 0.5px 0.7px 1px 0px #FFFFFF4D inset;
    box-shadow: 0px -0.3px 0.4px 0px #FFFFFF40 inset;
    .ant-popover-inner-content{
      padding: 8px;
    }

  }
}
</style>
